import { environment } from '../../../environments/environment';

export const APPCONFIG: any = {
  sessionCookieStorageKey: 'cookie-session-data',
  serverConfig: {
    grant_type: 'password',
    client_id: 2,
    client_secret: 'xxp3tsXSuDXvsElpfMdi6OR6gsLL2PsDAHozZBX4'
  },
  endpoints: environment.endpoints
};
